// Excavation Materials Database (Bank Cubic Yards and Cubic Yards)
// BCY = Bank Cubic Yards (material in natural state)
// LCY = Loose Cubic Yards (material after excavation, increases in volume)
// Default costs are typical excavation/hauling rates per BCY

export const excavationDatabase = [
  // === SOIL & EARTH ===
  {
    name: 'Common Earth (Dry)',
    category: 'Soil & Earth',
    tonsPerBCY: 1.4,
    swellFactor: 1.25,
    defaultCostPerBCY: 8.50,
    description: 'Typical dry earth and soil'
  },
  {
    name: 'Common Earth (Moist)',
    category: 'Soil & Earth',
    tonsPerBCY: 1.6,
    swellFactor: 1.25,
    defaultCostPerBCY: 9.50,
    description: 'Moist earth and soil'
  },
  {
    name: 'Common Earth (Wet)',
    category: 'Soil & Earth',
    tonsPerBCY: 1.8,
    swellFactor: 1.3,
    defaultCostPerBCY: 12.00,
    description: 'Wet saturated earth'
  },
  {
    name: 'Topsoil (Dry)',
    category: 'Soil & Earth',
    tonsPerBCY: 1.1,
    swellFactor: 1.25,
    defaultCostPerBCY: 7.50,
    description: 'Dry topsoil excavation'
  },
  {
    name: 'Topsoil (Moist)',
    category: 'Soil & Earth',
    tonsPerBCY: 1.3,
    swellFactor: 1.25,
    defaultCostPerBCY: 8.50,
    description: 'Moist topsoil excavation'
  },
  {
    name: 'Fill Dirt',
    category: 'Soil & Earth',
    tonsPerBCY: 1.4,
    swellFactor: 1.25,
    defaultCostPerBCY: 8.00,
    description: 'Fill dirt excavation'
  },
  {
    name: 'Loam',
    category: 'Soil & Earth',
    tonsPerBCY: 1.2,
    swellFactor: 1.2,
    defaultCostPerBCY: 8.5,
    description: 'Loam soil excavation'
  },
  
  // === CLAY ===
  {
    name: 'Clay (Dry)',
    category: 'Clay',
    tonsPerBCY: 1.6,
    swellFactor: 1.3,
    defaultCostPerBCY: 12.0,
    description: 'Dry clay excavation'
  },
  {
    name: 'Clay (Damp)',
    category: 'Clay',
    tonsPerBCY: 1.7,
    swellFactor: 1.3,
    defaultCostPerBCY: 12.0,
    description: 'Damp clay excavation'
  },
  {
    name: 'Clay (Wet)',
    category: 'Clay',
    tonsPerBCY: 1.8,
    swellFactor: 1.35,
    defaultCostPerBCY: 12.0,
    description: 'Wet clay excavation'
  },
  {
    name: 'Clay & Gravel (Dry)',
    category: 'Clay',
    tonsPerBCY: 1.6,
    swellFactor: 1.3,
    defaultCostPerBCY: 12.0,
    description: 'Clay mixed with gravel'
  },
  {
    name: 'Clay & Gravel (Wet)',
    category: 'Clay',
    tonsPerBCY: 1.9,
    swellFactor: 1.35,
    defaultCostPerBCY: 12.0,
    description: 'Wet clay with gravel'
  },
  
  // === SAND & GRAVEL ===
  {
    name: 'Sand (Dry)',
    category: 'Sand & Gravel',
    tonsPerBCY: 1.4,
    swellFactor: 1.12,
    defaultCostPerBCY: 9.0,
    description: 'Dry sand excavation'
  },
  {
    name: 'Sand (Damp)',
    category: 'Sand & Gravel',
    tonsPerBCY: 1.5,
    swellFactor: 1.12,
    defaultCostPerBCY: 9.0,
    description: 'Damp sand excavation'
  },
  {
    name: 'Sand (Wet)',
    category: 'Sand & Gravel',
    tonsPerBCY: 1.7,
    swellFactor: 1.15,
    defaultCostPerBCY: 9.0,
    description: 'Wet sand excavation'
  },
  {
    name: 'Sand & Gravel (Dry)',
    category: 'Sand & Gravel',
    tonsPerBCY: 1.5,
    swellFactor: 1.12,
    defaultCostPerBCY: 9.0,
    description: 'Dry sand and gravel mix'
  },
  {
    name: 'Sand & Gravel (Wet)',
    category: 'Sand & Gravel',
    tonsPerBCY: 1.7,
    swellFactor: 1.15,
    defaultCostPerBCY: 9.0,
    description: 'Wet sand and gravel mix'
  },
  {
    name: 'Gravel (Dry)',
    category: 'Sand & Gravel',
    tonsPerBCY: 1.5,
    swellFactor: 1.12,
    defaultCostPerBCY: 9.0,
    description: 'Dry gravel excavation'
  },
  {
    name: 'Gravel (Wet)',
    category: 'Sand & Gravel',
    tonsPerBCY: 1.7,
    swellFactor: 1.15,
    defaultCostPerBCY: 9.0,
    description: 'Wet gravel excavation'
  },
  
  // === ROCK ===
  {
    name: 'Rock (Blasted)',
    category: 'Rock',
    tonsPerBCY: 2.0,
    swellFactor: 1.5,
    defaultCostPerBCY: 85.0,
    description: 'Blasted rock excavation'
  },
  {
    name: 'Rock (Ripped)',
    category: 'Rock',
    tonsPerBCY: 1.9,
    swellFactor: 1.4,
    defaultCostPerBCY: 85.0,
    description: 'Ripped rock excavation'
  },
  {
    name: 'Shale',
    category: 'Rock',
    tonsPerBCY: 1.8,
    swellFactor: 1.35,
    defaultCostPerBCY: 85.0,
    description: 'Shale rock excavation'
  },
  {
    name: 'Limestone',
    category: 'Rock',
    tonsPerBCY: 2.1,
    swellFactor: 1.4,
    defaultCostPerBCY: 85.0,
    description: 'Limestone excavation'
  },
  {
    name: 'Sandstone',
    category: 'Rock',
    tonsPerBCY: 2.0,
    swellFactor: 1.4,
    defaultCostPerBCY: 85.0,
    description: 'Sandstone excavation'
  },
  
  // === MIXED MATERIALS ===
  {
    name: 'Earth & Rock Mix',
    category: 'Mixed Materials',
    tonsPerBCY: 1.7,
    swellFactor: 1.35,
    defaultCostPerBCY: 18.0,
    description: 'Mixed earth and rock'
  },
  {
    name: 'Silt',
    category: 'Mixed Materials',
    tonsPerBCY: 1.3,
    swellFactor: 1.25,
    defaultCostPerBCY: 18.0,
    description: 'Silt excavation'
  },
  {
    name: 'Hardpan',
    category: 'Mixed Materials',
    tonsPerBCY: 1.8,
    swellFactor: 1.3,
    defaultCostPerBCY: 18.0,
    description: 'Hardpan excavation'
  },
  {
    name: 'Caliche',
    category: 'Mixed Materials',
    tonsPerBCY: 1.7,
    swellFactor: 1.3,
    defaultCostPerBCY: 18.0,
    description: 'Caliche material'
  },
  
  // === ORGANIC MATERIALS ===
  {
    name: 'Peat',
    category: 'Organic Materials',
    tonsPerBCY: 0.6,
    swellFactor: 1.2,
    defaultCostPerBCY: 12.0,
    description: 'Peat excavation'
  },
  {
    name: 'Muck',
    category: 'Organic Materials',
    tonsPerBCY: 0.8,
    swellFactor: 1.25,
    defaultCostPerBCY: 12.0,
    description: 'Muck excavation'
  },
  {
    name: 'Organic Soil',
    category: 'Organic Materials',
    tonsPerBCY: 0.9,
    swellFactor: 1.2,
    defaultCostPerBCY: 12.0,
    description: 'Organic rich soil'
  },
  
  // === DEMOLISHED MATERIALS ===
  {
    name: 'Asphalt Pavement',
    category: 'Demolished Materials',
    tonsPerBCY: 2.0,
    swellFactor: 1.3,
    defaultCostPerBCY: 12.0,
    description: 'Broken asphalt pavement'
  },
  {
    name: 'Concrete (Unreinforced)',
    category: 'Demolished Materials',
    tonsPerBCY: 2.2,
    swellFactor: 1.35,
    defaultCostPerBCY: 12.0,
    description: 'Broken concrete without rebar'
  },
  {
    name: 'Concrete (Reinforced)',
    category: 'Demolished Materials',
    tonsPerBCY: 2.4,
    swellFactor: 1.4,
    defaultCostPerBCY: 12.0,
    description: 'Broken concrete with rebar'
  },
  {
    name: 'Brick',
    category: 'Demolished Materials',
    tonsPerBCY: 1.8,
    swellFactor: 1.3,
    defaultCostPerBCY: 12.0,
    description: 'Broken brick material'
  }
];